import React from "react";
export default () => (
	<a className="skip-to" href="#main">
		<span>Skip to main content</span>
	</a>
);



// WEBPACK FOOTER //
// ./src/components/SkipTo.js